import React from "react";

import * as iconComponents from "./icons";
const Icon = (props) => {
  const { className = "", name } = props;
  return <img src={iconComponents?.[name]} alt="" className={`${className}`} />;
};

export default Icon;
